import * as React from 'react';
import classNames from 'classnames';

import { ContentSettings } from './ContentSettings';

/**
 * Renders a content style editor.
 */
export class Content extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { over: false };

        /**
         * Call `onToggle` with the current area name (`'content'`).
         *
         * @param  {Object} occurrence The event object.
         */
        this.toggleActive = (occurrence) => this.props.onToggle('content', occurrence);

        this.onMouseEnter = () => this.setState({ over: true });
        this.onMouseLeave = () => this.setState({ over: false });
    }

    render() {
        const { value, name: key, active, onChange, defaults } = this.props;
        const { over } = this.state;

        return (
            <div className={classNames('widget-style-content', active && 'widget-style-content--is-active')}>
                <div className="widget-style-content__wrapper widget-style-content__wrapper--top">
                    <div className="widget-style-content__outside">
                        <div
                            className={classNames(
                                'widget-style-content__inside',
                                over && 'widget-style-content__inside--is-focus',
                            )}
                            onMouseEnter={this.onMouseEnter}
                            onMouseLeave={this.onMouseLeave}
                            onClick={this.toggleActive}
                        />
                    </div>
                </div>
                <div className="widget-style-content__settings">
                    {active && <ContentSettings value={value} name={key} onChange={onChange} defaults={defaults} />}
                </div>
                <div className="widget-style-content__wrapper widget-style-content__wrapper--bottom">
                    <div className="widget-style-content__outside">
                        <div
                            className={classNames(
                                'widget-style-content__inside',
                                over && 'widget-style-content__inside--is-focus',
                            )}
                            onMouseEnter={this.onMouseEnter}
                            onMouseLeave={this.onMouseLeave}
                            onClick={this.toggleActive}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
